import React from "react";
import { Text, TextProps, Tag, TagProps, Flex } from "@jsq/ds/core";
import { textStyle, tagStyle } from "./styles_vanilla.css";

export type TextWithTagProps = {
  label: string;
  tagLabel?: string;
  textVariant?: TextProps["variant"];
  tagVariant?: TagProps["variant"];
};

/**
 * Used to display a text with a tag to the right.
 * Eg: "Positon Name [Payment instructions updated]"
 */
export const TextWithTag: React.FC<TextWithTagProps> = (props) => {
  const { label, tagLabel, textVariant, tagVariant = "neutral" } = props;
  return (
    <Flex flexDirection="row" alignItems="center">
      <Text variant={textVariant} className={textStyle}>
        {label}
      </Text>
      {tagLabel && (
        <Tag variant={tagVariant} className={tagStyle}>
          {tagLabel}
        </Tag>
      )}
    </Flex>
  );
};
